//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/**
 * The type of action to be performed in response to interacting with
 * a notification message.
 */
export const NotificationMessageActionType = {
    /**
     * No action can be performed. Either the notification is no longer
     * valid or it is not valid in this context.
     */
    Invalid: 0,

    /** Show a simple text message. */
    ShowMessage: 1,

    /**
     * Link to a page. The URL will be encoded for the type of site
     * that is requesting the action.
     */
    LinkToPage: 2
} as const;

/**
 * The type of action to be performed in response to interacting with
 * a notification message.
 */
export const NotificationMessageActionTypeDescription: Record<number, string> = {
    0: "Invalid",

    1: "Show Message",

    2: "Link To Page"
};

/**
 * The type of action to be performed in response to interacting with
 * a notification message.
 */
export type NotificationMessageActionType = typeof NotificationMessageActionType[keyof typeof NotificationMessageActionType];
